import { useContext } from "react";
import { PayActionContext } from "./PayActionContext";

function useInitialize() {
  const { setElement, setShowModal } = useContext(PayActionContext);
  return (formDefaultValues: any) => {
    setElement(formDefaultValues);
    setShowModal(true);
  };
}

export default useInitialize;
